<template>
  <div class="container-fluid" v-if="school">
    <div class="justify-content-between">
      <div>
        <h2>{{ school.name }}</h2>
        <div class="container">
          <div class="row justify-content-start">
            <span v-for="(dep, index) in departments" :key="index">
              <span v-for="(program, pindex) in dep.programs" :key="pindex">
                <span
                  style="cursor: pointer"
                  class="mr-1 p-1 program-select"
                  @click="_clickDepartmentAndProgram(dep, program)"
                  :class="
                    selectedDepartment != null &&
                    selectedProgram != null &&
                    selectedDepartment.id == dep.id &&
                    selectedProgram.id == program.id
                      ? 'badge badge-danger text-white'
                      : ''
                  "
                  >{{ dep.name }}{{ program.name.toUpperCase() }}
                </span>
              </span>
            </span>
          </div>
        </div>
        <h4 class="mt-4">Сурагч мэдээлэл нэмэх</h4>
      </div>
      <div>
        <div>
          <p>
            Формат: Энэxүү дарааллаар оруулаx (Овог Нэр Регистр Имэйл Сурагчийн
            код)
          </p>
          <div class="form-group">
            <textarea
              rows="10"
              v-model.trim="teachersText"
              class="form-control"
              placeholder="Сурагч нарын мэдээлэл"
            />
          </div>

          <button type="button" class="btn btn-danger" @click="addTeachers">
            Сурагч нэмэх
          </button>
          <hr />
        </div>
        <hr />
      </div>
    </div>
    <div class="card shadow my-4">
      <div class="card-header py-3">
        <h6 class="m-0 font-weight-bold text-primary">
          Хадгалах сурагчдын жагсаалт ({{ tmpTeachers.length }})
        </h6>
      </div>
      <div class="card-body">
        <div
          class="table-responsive"
          v-if="tmpTeachers != null && tmpTeachers.length > 0"
        >
          <button class="btn btn-sm btn-primary mb-2" @click="_saveAll">
            Бүгдийг хадгалах
          </button>
          <table
            class="table table-bordered"
            id="dataTable"
            width="100%"
            cellspacing="0"
          >
            <thead>
              <tr>
                <th>№</th>
                <th>Овог</th>
                <th>Нэр</th>
                <th>Регистр</th>
                <th>Имэйл</th>
                <th>Код</th>
                <th>gender</th>
                <th>Үйлдэл</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(item, index) in tmpTeachers" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.lastname }}</td>
                <td>{{ item.name }}</td>

                <td>{{ item.register }}</td>
                <td>{{ item.email }}</td>
                <td>{{ item.code }}</td>
                <td>{{ item.gender}}</td>
                <td>
                  <button
                    class="btn btn-danger btn-sm"
                    @click="deleteTeacher(item, index)"
                  >
                    хасах
                  </button>
                  <button
                    class="btn btn-primary btn-sm"
                    @click="_save(item, index, true)"
                  >
                    хадгалах
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="alert alert-info text-center">
          Одоогоор мэдээлэл ороогүй байна.
        </div>
      </div>
    </div>

    <div
      v-if="loading == true"
      style="position: fixed; z-index: 10000000; top: 45%; left: 45%"
    >
      <div class="spinner-grow text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-success" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-danger" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-warning" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-info" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-dark" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("../../firebaseConfig.js");

export default {
  data() {
    return {
      selectedDepartment: null,
      selectedProgram: null,
      teachers: [],
      teachersText: null,
      tmpTeachers: [],
      school: null,
      department: null,
      program: null,
      loading: false,
      departments: null,
    };
  },
  props: {
    schoolId: {
      required: true,
    },
    // departmentId:{
    //     required:true
    // },
    // programId:{
    //     required:true
    // }
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  methods: {
    _clickDepartmentAndProgram(dep, program) {
      this.selectedDepartment = dep;
      this.selectedProgram = program;
      console.log(this.selectedDepartment, this.selectedProgram);
    },
    _getProgramId(depName, programName) {
      var foundDep = null;
      var foundProg = null;
      for (var dep of this.departments) {
        console.log(dep.name, depName);
        if (dep.name == depName) {
          foundDep = dep;
          for (var prog of dep.programs) {
            console.log(prog.name, programName);
            if (prog.name == programName) foundProg = prog;
          }
        }
      }
      return [foundDep, foundProg];
    },
    _getData() {
      fb.db
        .collection("schools")
        .doc(this.schoolId)
        .get()
        .then((schoolData) => {
          if (schoolData.exists) {
            let school = schoolData.data();
            school.id = schoolData.id;
            school.ref = schoolData.ref;
            this.school = school;

            console.log(this.school.currentYear);
            fb.db
              .collection("schools")
              .doc(this.schoolId)
              .collection("departments")
              .where("startYear", "==", this.school.currentYear)
              .orderBy("createdAt", "desc")
              .onSnapshot((querySnapshot) => {
                this.departments = [];
                querySnapshot.forEach((doc) => {
                  let dep = doc.data();
                  dep.id = doc.id;
                  dep.ref = doc.ref;
                  dep.programs = [];
                  this.departments.push(dep);

                  fb.db
                    .collection(
                      "schools/" +
                        this.schoolId +
                        "/departments/" +
                        dep.id +
                        "/programs"
                    )
                    .orderBy("name", "asc")
                    .onSnapshot((querySnapshot) => {
                      querySnapshot.forEach((doc) => {
                        let program = doc.data();
                        program.id = doc.id;
                        program.ref = doc.ref;
                        dep.programs.push(program);
                        ///console.log(dep.name, program.name, dep.ref.path, program.ref.path);
                      });
                    });
                });
              });
          }
        });
    },
    addTeachers() {
      if (this.selectedProgram != null && this.selectedDepartment != null) {
        if (this.teachersText != null && this.teachersText != "") {
          //TODO
          var arrayOfLines = this.teachersText.match(/[^\r\n]+/g);
          this.tmpTeachers = [];
          arrayOfLines.forEach((value) => {
            //console.log(value);
            var lineArray = value.split("\t");

            if (
              lineArray != null &&
              lineArray[0] != null &&
              lineArray[0] != "" &&
              lineArray[1] != null &&
              lineArray[1] != "" &&
              lineArray[2] != null &&
              lineArray[2] != "" &&
              lineArray[3] != null &&
              lineArray[3] != "" &&
              lineArray[4] != null &&
              lineArray[4] != "" 
              &&
              lineArray[5] != null &&
              lineArray[5] != "" 
              // lineArray[6] != null &&
              // lineArray[6] != ""
            ) {
              var genderString = lineArray[5];
              var gender = null;
              if (genderString) {
                genderString = genderString.toLowerCase();


                if (genderString == "эрэгтэй") gender = 0;
                else if (genderString == "эмэгтэй") gender = 1;
                else if (genderString == "эр") gender = 0;
                else if (genderString == "эм") gender = 1;
                else gender = -1;
              }
              // var foundDepProg = this._getProgramId(
              //   lineArray[0].trim(),
              //   lineArray[1].trim()
              // );

              var studentDtail = {
                depNumber: lineArray[0].trim(),
                programNumber: lineArray[1].trim(),

                lastname: lineArray[0].trim(),
                name: lineArray[1].trim(),
                register: lineArray[2].toLowerCase().trim(),
                gender: gender,
                email: lineArray[3].toLowerCase().trim(),
                code: lineArray[4].toLowerCase().trim(),

                created: fb.usersCollection.doc(
                  this.$store.getters.currentUser.uid
                ),
                createdAt: new Date(),
                verified: false,
                school: fb.db.doc("schools/" + this.schoolId),
                department: this.selectedDepartment.ref,
                program: this.selectedProgram.ref,
                departmentName: this.selectedDepartment.name.toLowerCase(),
                programName: this.selectedProgram.name.toLowerCase(),
              
              };
              this.tmpTeachers.push(studentDtail);
            }
          });
          this.teachersText = "";
        }
      } else {
        confirm("Ямар анги, бүлэгт нэмэxээ сонгоно уу!");
      }
    },
    deleteTeacher(item, index) {
      if (item) {
        this.tmpTeachers.splice(index, 1);
      }
    },
    async _save(data, index, remove) {
      if (data != null && data != undefined) {
        var batch = fb.db.batch();
        this.loading = true;
        var ts = await fb.db
          .collection("schools/" + this.schoolId + "/students")
          .where("register", "==", data.register)
          .limit(1)
          .get();
        if (ts.empty) {
          var tmpItem = {
            lastname: data.lastname,
            name: data.name,
            register: data.register,
            gender: data.gender,
            code: data.code,
            email: data.email,
            created: data.created,
            createdAt: data.createdAt,
            verified: data.verified,
            school: data.school,
            learningType: "active"
            // department: data.department,
            // program: data.program,
            // departmentName: data.departmentName,
            // programName: data.programName,
          };
          tmpItem["program-" + this.selectedDepartment.startYear] =
            data.program;
          tmpItem["department-" + this.selectedDepartment.startYear] =
            data.department;

          tmpItem["programName-" + this.selectedDepartment.startYear] =
            this.selectedProgram.name
          tmpItem["departmentName-" + this.selectedDepartment.startYear] =
            this.selectedDepartment.name;

          var studentRef = fb.db
            .doc("schools/" + this.schoolId)
            .collection("students")
            .doc();

          batch.set(studentRef, tmpItem);
          batch.update(fb.db.collection("schools").doc(this.schoolId), {
            numberOfStudents: fb.firestore.FieldValue.increment(1),
          });

          await batch.commit();
        } else {
          var tmpItem = {};
          tmpItem["code"] = data.code;
          tmpItem["email"] = data.email;
          tmpItem["gender"] = data.gender;
          tmpItem["learningType"] = "active"
           
          tmpItem["program-" + this.selectedDepartment.startYear] =
            data.program;
          tmpItem["department-" + this.selectedDepartment.startYear] =
            data.department;

          tmpItem["programName-" + this.selectedDepartment.startYear] =
            this.selectedProgram.name
          tmpItem["departmentName-" + this.selectedDepartment.startYear] =
            this.selectedDepartment.name;
 
          if (ts.docs[0].exists) {
            batch.update(ts.docs[0].ref, tmpItem);
            await batch.commit();
          }
        }

        this.loading = false;
      }
      if (remove != null && remove == true) this.tmpTeachers.splice(index, 1);
    },
    async _saveAll() {
      if (this.tmpTeachers != null && this.tmpTeachers.length > 0) {
        var r = confirm(
          "Бүгдийг хадгалах уу. Та хадгалагдаж дуустал вэбээс гаралгүй хүлээнэ үү"
        );
        if (r == true) {
          var i = 0;
          for (const value of this.tmpTeachers) {
            await this._save(value, i, false);
          }
          this.tmpTeachers = [];
          alert("Амжилттай хадгаллаа");
          this.$router.back();
        }
      }
    },
  },
  created() {
    this._getData();
  },

  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).format("MM/DD/YYYY HH:mm");
    },
    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    },
  },
};
</script>
<style>
.program-select:hover {
  text-decoration: underline;
  color: #000;
}
.program-select {
  color: #aaa;
}
</style>